import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusSquare, faPlusSquare} from "@fortawesome/free-solid-svg-icons";
import ConsignmentFromToDateTime from "../stolen/ConsignmentFromToDateTime";
import VehicleHireStatusBadge from "./VehicleHireStatusBadge";
import DriverDefinitionList from "../common/DriverDefinitionList";
import VehicleHirePaymentMethodDefinitionList from "./VehicleHirePaymentMethodDefinitionList";
import WaypointComponent from "../common/WaypointComponent";
import VehicleHireDocketGallery from "./VehicleHireDocketGallery";
import VehicleHireDocketDownloadButton from "./VehicleHireDocketDownloadButton";

interface VehicleHiresListProps {
    vehicleHires: CustomerAPIVehicleHire[]
    expandedIds: Set<number>;
    onToggleExpand: (consignmentId: number) => void;
}

const VehicleHiresList = (props: VehicleHiresListProps) => {

    if (props.vehicleHires.length < 1) {
        return (
            <div className="row">
                <div className="col-12">
                    <p className="text-center">No Vehicle Hires found</p>
                </div>
            </div>
        )
    }

    return props.vehicleHires.map(vehicleHire => {
        // const vehicleHire = this.props.vehicleHire;

        const startingLocation = vehicleHire.locations.find(location => location.type === "STARTING");
        const deliveryLocation = vehicleHire.locations.find(location => location.type === "DELIVERY");

        const {driver} = vehicleHire;
        const expanded = props.expandedIds.has(vehicleHire.id);

        return (
            <React.Fragment key={vehicleHire.id}>
                <div className="row">
                    <div className="col-1" onClick={() => props.onToggleExpand(vehicleHire.id)}>
                        <FontAwesomeIcon icon={expanded ? faMinusSquare : faPlusSquare} size="lg"/>&nbsp;
                    </div>
                    <div className="col-3">
                        <strong>Date / Time</strong><br/>
                        <ConsignmentFromToDateTime fromDateTime={vehicleHire.hireFrom} toDateTime={vehicleHire.hireTo}/>
                    </div>
                    <div className="col-4">
                        <strong>Hire Reference</strong><br/>
                        {vehicleHire.ref}<br/>
                        <strong>Your Reference</strong><br/>
                        {vehicleHire.customerRef ?? <>&mdash;</>}
                    </div>
                </div>

                <div className="row">
                    <div className="col-4">
                        <strong>Vehicle Type</strong><br/>
                        {vehicleHire.allocatedVehicle?.vehicleTypeDescription
                            ?? vehicleHire.preferredVehicleType.description}<br />
                        {vehicleHire.allocatedVehicle?.registration}
                    </div>
                    <div className="col-4">
                        <strong>Pay By</strong><br/>
                        <p><span className="badge bg-dark p-2">{vehicleHire.paymentMethod}</span></p>
                    </div>
                    <div className="col-4">
                        <strong>Status</strong><br/>
                        <p>
                            <VehicleHireStatusBadge vehicleHire={vehicleHire}/>
                        </p>
                    </div>
                </div>

                {expanded &&

                    <div className="row">

                        {driver &&
                            <div className="col-6">
                                <DriverDefinitionList driver={driver}/>
                            </div>
                        }

                        <div className="col-6">
                            <VehicleHirePaymentMethodDefinitionList vehicleHire={vehicleHire}/>
                        </div>

                    </div>
                }

                <div className="row">
                    <div className="col-6">
                        {startingLocation &&
                            <>
                                <strong>Start Location</strong><br/>
                                <WaypointComponent waypoint={startingLocation} detailed={expanded}/>
                            </>
                        }
                    </div>
                    <div className="col-6">
                        {deliveryLocation &&
                            <>
                                <strong>Delivery Location</strong><br/>
                                <WaypointComponent waypoint={deliveryLocation} detailed={expanded}/>
                            </>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <VehicleHireDocketGallery vehicleHire={vehicleHire} hidden={!expanded} />
                        <VehicleHireDocketDownloadButton vehicleHire={vehicleHire}/>
                    </div>
                </div>
                <br/>
                <hr className="py-0 my-0"/>
            </React.Fragment>
        )
    })

}

export default VehicleHiresList;
